import React from "react"
import { Card, Grid, Header } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as CharityGoalIcon } from "uikit/Icons/charity-goal.svg"
import { formatCurrency } from "uikit"

const Charity = ({
  id,
  description,
  people,
  baseUrl,
  amount,
  type,
  start_year,
  years_duration
}) => {
  const yearText = years_duration > 1 ? "years duration" : "year duration"
  return (
    <Card>
      <Card.Content>
        <Link
          to={`${baseUrl}/goals/${id}/${type.toLowerCase()}`}
          className="navlink"
        >
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column verticalAlign="middle" width={4}>
                <CharityGoalIcon />
                <Header
                  as="h2"
                  content={start_year}
                  textAlign="center"
                  style={{ marginTop: "0" }}
                />
              </Grid.Column>
              <Grid.Column>
                <Grid>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <span className="GenericCard__LinkTitle">
                        {` ${description}`}
                      </span>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2} style={{ paddingTop: "0px" }}>
                    <Grid.Column>
                      <p
                        className="GoalCard_Price"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {formatCurrency(amount)}
                      </p>{" "}
                      <p className="greyed-text">per year</p>
                    </Grid.Column>
                    <Grid.Column
                      style={{ paddingRight: "24px", textAlign: "right" }}
                      className="greyed-text"
                    >
                      <p
                        className="GoalCard_SecondText"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {years_duration}
                      </p>
                      <p className="greyed-text"> {yearText}</p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Link>
      </Card.Content>
    </Card>
  )
}
export default Charity
